import { Link } from "react-router-dom";
import { connect } from "react-redux";

var Features = require("lib/account/Features");
var GradeLevel = require("lib/academic/GradeLevel");
var CurrentUser = require("lib/account/CurrentUser");
var QuestionTypes = require("lib/academic/QuestionTypes");

var AnswerDisplay = require("components/writing/answers/AnswerDisplay");
var BookDisplay = require("components/reading/books/BookDisplay")
var GradualFade = require("components/utility/GradualFade");
var Spinner = require("components/utility/Spinner");
var Glyphicon = require("components/utility/icons/Glyphicon");

var StudentDisplay = require("components/users/students/StudentDisplay");
var ScoreDisplay = require("components/writing/evaluations/ScoreDisplay");
var DisplayToggleControl = require("components/utility/DisplayToggleControl")
var EditControls = require("components/writing/controls/EditControls");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var WritingActions = require("lib/actions/WritingActions");

var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");

require("writing/quizzes/quiz_display.scss");

@connect(
	(state, props) => {
		var quiz = WritingSelectors.quiz({ state, id: props.quizID });

		var requiredRecords = {
			quiz: quiz
		}
		var student = RosterSelectors.student({ state, id: quiz.user_id });
		if (student) {
			requiredRecords.studentReadingLevel = student.current_reading_level;
		}
		var answers = WritingSelectors.answersForQuizID({ state, quizID: props.quizID });
		if (!CurrentUser.isPremiumOrTrialAccount()) {
			answers = _.filter(answers, answer => { return answer.question_type !== QuestionTypes.FILL_IN_THE_BLANK_QUESTION })
		}
		requiredRecords.answerIDs = _.pluck(answers, "id")

		if (answers) {
			requiredRecords.evaluations = _.compact(_.map(_.pluck(answers, "id"), (id) => {
				return WritingSelectors.evaluationForSubject({ state, subjectType: "Answer", subjectID: id});
			}))
			requiredRecords.answers = answers
		}

		return requiredRecords;
	}, 
	(dispatch, props) => ({
		skipRevision: () => {
			return dispatch(WritingActions.updateQuiz({
				id: props.quizID , update: { allow_revision: false }, query: { skip: true }
			})).then(() => {
				CurrentUser.fetchCurrentUserCoinData();
			})
		},
		fetchAnswers: (answerIDs) => {
			var filters = { ids: answerIDs }
			var embeds = ["answer.question", "answer.meta_data", "answer.evaluation", "question.answer_options", "evaluation.autograder_data"]
			return dispatch(WritingActions.fetchAnswers({ filters, embeds }))
		},
		updateEvaluation: (evaluationID, update) => {
			dispatch(WritingActions.updateEvaluation({ id: evaluationID, update }))
		},
	})
)
class QuizDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			controlMode: props.controlMode ? props.controlMode : null
		}
	}

	controlMode() {
		return this.state.controlMode; // Kept as a funciton to mirror AnswerDisplay
	}

	onModeChange(controlMode) {
		this.setState({ controlMode }, () => this.updateEvaluationAsViewed());
		setTimeout($wr.triggerResize, 400);
	}

	// Updates quiz evaluation as viewed
	updateEvaluationAsViewed() {
		var { quiz } = this.props
		var { controlMode } = this.state

		if (quiz.evaluation && (controlMode == AnswerDisplay.ANALYSIS_CONTROLS || controlMode == AnswerDisplay.EDIT_CONTROLS) && !CurrentUser.isStudent()) {
			this.props.updateEvaluation(quiz.evaluation, { viewed: true })
		}
	}

	closeControl(e) {
		$wr.nope(e);
		this.setState({ controlMode: null });
	}

	onSkipRevision() {
		if (confirm("Are you sure?")) {
			this.props.skipRevision();
		}
	}

	// Function to remove a query parameter from the URL
	removeQueryParam(url, paramToRemove){
		var urlObject = new URL(url);
		urlObject.searchParams.delete(paramToRemove);
		return urlObject.toString();
	};

	afterDelete(e) {
		$wr.nope(e);

		// Get the current URL
		var currentURL = window.location.href;

		// Remove the query parameter 'quizz_id'
		var updatedURL = this.removeQueryParam(currentURL, 'quiz_id');
	
		// Redirect to the updated URL
		window.location.href = updatedURL;
	}

	renderAnswers() {
		var baseAnswerEnabled = _.pick(this.props.enabled,
			"lowerComments", "answerKey", "allowRevision"
		)

		return _.map(this.props.answerIDs, (answerID, index) => {
			var answerEnabled = _.clone(baseAnswerEnabled);
			var wrapClass = "answerWrap answerIndex" + index;

			if (index == this.props.answerIDs.length - 1) {
				wrapClass += " answerLastIndex";
			} else {
				delete answerEnabled.allowRevision;
			}

			if (this.controlMode() === AnswerDisplay.EDIT_CONTROLS) {
				if (index === 0) {

					var editControlEnabled = _.pick(
						this.props.enabled,
						"editScore",
						"deletion",
						"toggleInclude",
					)

					// Make the first answer show the controls for the quiz
					var controlContent = (
						<EditControls quizID={ this.props.quiz.id } enabled={ editControlEnabled } afterDelete={ this.afterDelete } />
					);
				} else {
					// Hide edit controls for later answers
					var controlContent = null;
				}
			}
			return (
				<div className={ wrapClass } key={ answerID }>
					<AnswerDisplay answerID={answerID}
						onModeChange={this.onModeChange}
						enabled={ answerEnabled }
						controlMode={ this.state.controlMode }
						controlContent={ controlContent }
						viewAsStudent={ this.props.viewAsStudent }
						onCloseControl={ this.closeControl }
						suppressControlHeader={ index !== 0 } />
				</div>
			);
		});
	}

	toggleEdit() {
		this.props.onEditEvaluation()
	}

	renderFirstRow() {
		var { enabled, quiz } = this.props;

		if (enabled.student) {
			var studentDisplay = (
				<StudentDisplay studentID={ quiz.user_id } showAvatar avatarMaxWidth={ 40 } />
			);
		}

		if (enabled.date) {
			var dateDisplay = (
				<div className="date">
					{ $wr.formatDateTime(quiz.completed_at, "show-past-years") }
				</div>
			);
		}

		if (enabled.score) {
			var scoreDisplay = (
				<ScoreDisplay showDenominator subjectID={ quiz.id }
					subjectType={ "Quiz" } mode={ ScoreDisplay.CIRCLE_MODE } answerIDs={this.props.answerIDs}/>
			);
		}

		if ((enabled.startRevision || enabled.cancelRevision) && quiz.allow_revision) {
			if (enabled.startRevision) {
				var goToRevision = (
					<Link className="btn buttonPrimary revisionButton"
						to={ "/quiz?text_id=" + quiz.text_id }>
						Start Revision
					</Link>
				);
			}

			if (enabled.cancelRevision) {
				var cancelRevision = (
					<button className="btn btn-default revisionButton"
						onClick={ this.onSkipRevision }>
						Skip
					</button>
				);
			}

			var revisionButtons = (
				<div>
					<p>Your teacher will let you revise this quiz.</p>
					{ goToRevision }
					{ cancelRevision }
				</div>
			);
		}

		if (studentDisplay || dateDisplay || scoreDisplay) {
			return (
				<div className="quizDisplayRow topRow clearfix">
					<div className="pull-left">
						{ revisionButtons }
						{ studentDisplay }
					</div>
					<div className="pull-right displayContainer">
						{ dateDisplay }
						{ scoreDisplay }
					</div>
				</div>
			)
		}
	}

	includeNewBadge() {
		return _.any(_.map(this.props.evaluations, function (evaluation) {
			var answerDetails = evaluation.autograder_data
			if (answerDetails) {
				var agKeys = _.keys(AutograderDisplayConfig.aggregateLeaves(answerDetails.polarizing));
				return agKeys.some(r => AutograderDisplayConfig.NEW_KEYS.includes(r))
			}
		}))
	}

	renderSecondRow() {
		var enabled = this.props.enabled;

		if (this.props.enabled.textTitle) {
			var bookDisplay = (
				<BookDisplay inline textID={ this.props.quiz.text_id }
					showReadingLevel={ enabled.readingLevel }
					studentReadingLevel={ this.props.studentReadingLevel } />
			)
		}

		var toggleOptions = [];

		if (enabled.editControls) {
			toggleOptions.push({
				key: AnswerDisplay.EDIT_CONTROLS,
				text: AnswerDisplay.EDIT_CONTROLS
			})
		}

		if (enabled.feedbackControls) {
			toggleOptions.push({
				key: AnswerDisplay.FEEDBACK_CONTROLS,
				text: AnswerDisplay.FEEDBACK_CONTROLS
			})
		}

		if (enabled.analysisControls) {
			var newBadge = this.includeNewBadge()
			toggleOptions.push({
				key: AnswerDisplay.ANALYSIS_CONTROLS,
				text: AnswerDisplay.ANALYSIS_CONTROLS,
				newBadge: newBadge
			})
		}

		if (toggleOptions.length) {
			var controlToggle = (
				<div className="hideOnPrint">
					<DisplayToggleControl options={ toggleOptions }
						mode={ DisplayToggleControl.LINK_MODE }
						onChange={ this.onModeChange } activeOptionKey={ this.controlMode() } />
				</div>
			);

		}

		if (bookDisplay || controlToggle) {
			return (
				<div className="quizDisplayRow secondRow clearfix">
					<div className="pull-left">
						{ bookDisplay }
					</div>
					<div className="pull-right">
						{ controlToggle }
					</div>
				</div>
			)
		}
	}

	render() {
		var { quiz, enabled } = this.props;

		var className = "quizDisplay writingDisplay";
		if (quiz.draft) {
			className += " draftAnswer";
		}

		if (this.controlMode()) {
			className += " controlMode" + this.controlMode().replace(/ /g, "");
		}

		// if (this.props.quiz.excluded) {
		// 	className += " excludedQuiz";

		// 	if (this.props.viewAsStudent) {
		// 		var exclusionNote = (
		// 			<p className="excludedText">
		// 				This quiz will not count toward your goals
		// 			</p>
		// 		)
		// 	} else {
		// 		var differentiationLink = (<Link to="/roster/goals?edit_expectations=true" >custom goals</Link>)
		// 		var exclusionNote = (
		// 			<p className="excludedText">
		// 				This quiz will not count toward your { differentiationLink }
		// 			</p>
		// 		)
		// 	}
		// }
					// { exclusionNote }
		return (
			<div data-quiz-id={this.props.quizID} data-evaluation-id={this.props.quiz.evaluation} className={ className }>
				{ this.renderFirstRow() }
				{ this.renderSecondRow() }
				{ this.renderAnswers() }
			</div>
		);
	}

	componentDidMount() {
		var { quiz, answers } = this.props
		// fetch answers and evaluations when empty
		if (quiz.answer_ids && _.isEmpty(answers)) {
			this.props.fetchAnswers(quiz.answer_ids)
		}

		this.updateEvaluationAsViewed()
	}
}

QuizDisplay.defaultProps = {
	enabled: {}
}

QuizDisplay.WrappedComponent.propTypes = StrictPropTypes({
	// ID of the quiz to be displayed
	quizID: PropTypes.number.isRequired,


	// Former "show" props
	//
	// "enabled" keys used in *this (quiz)* component
	//   date 					-> shows date
	//   student 				-> shows student + avatar
	//   score 					-> shows the scoring circle in the upper right
	//   textTitle 				-> shows the title of the book
	//   readingLevel 			-> shows the reading level of the book
	//   editControls			-> shows the controls to toggle into edit mode
	//   feedbackControls		-> shows the controls to toggle into feedback mode
	//   analysisControls		-> shows the controls to toggle into analysis model
	//
	// Values passed on to the *answer* component
	//   lowerComments			-> shows the comments UNDER the answer (not in feedback window)
	//   answerKey 				-> (FitB only) Show correct answers. Also triggered by edit mode
	//   allowRevision			-> Passed from answers -> controls  (But limited to last answer index)
	//
	// Values passed on to our *edit control* component within the quiz
	//   editScore				-> Passed from answers -> controls
	//   deletion 				-> Passed from answers -> controls
	//   toggleInclude			-> Passed from answers -> controls
	//
	enabled: PropTypes.object,

	view: PropTypes.string,
	controlMode: PropTypes.string,
	studentReadingLevel: PropTypes.number,
	evaluations: PropTypes.array,
	answers: PropTypes.array,

	// From @connect
	// Which are present is determined by the other props
	quiz: PropTypes.object.isRequired,
	answerIDs: PropTypes.array.isRequired,
	evaulation: PropTypes.object,
	onDelete: PropTypes.func,
	onRevert: PropTypes.func,
	onInclude: PropTypes.func,
	onExclude: PropTypes.func,
	hideWarmUps: PropTypes.bool,
	onEditEvaluation: PropTypes.func,
	skipRevision: PropTypes.func,
	fetchAnswers: PropTypes.func,
	updateEvaluation: PropTypes.func,

	viewAsStudent: PropTypes.bool
});

module.exports = QuizDisplay


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/QuizDisplay.js